
import { Component, Vue } from 'vue-property-decorator';

@Component<FullPageSpinner>({})
export default class FullPageSpinner extends Vue {}
